import styled, { css } from 'styled-components';
import { Text } from '../text/index.js';
import { suppressProps } from '../../utils/index.js';
const emphasised = {
    default: 'emphasised',
    emphasised: 'emphasised',
    compact: 'compactEmphasised',
    compactEmphasised: 'compactEmphasised',
    small: 'smallEmphasised',
    smallEmphasised: 'smallEmphasised',
    smallCompact: 'smallCompactEmphasised',
    smallCompactEmphasised: 'smallCompactEmphasised',
};
export const ParagraphElement = styled(Text).withConfig(suppressProps('variant'))(({ theme, variant = 'default', }) => {
    const { fontWeight } = theme.styles.paragraphs[emphasised[variant]];
    return css `
      strong {
        font-weight: ${theme.fontWeights[fontWeight]};
      }
    `;
});
//# sourceMappingURL=paragraph.styles.js.map